import { useTranslation } from 'react-i18next';

import Switch from '../../components/FormControls/Switch';
import Typography from '../../components/Typography';
import { i18nNS } from '../../i18n';
import BulbIcon from '../../icons/BulbIcon';
import SpinnerIcon from '../../icons/LoaderIcon';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '../styles';
import useHelpTipsVM from './vm';

const HELP_TIPS_LABEL_ID = 'help-tips';

const HelpTips = () => {
  const { t } = useTranslation([i18nNS.SETTINGS]);

  const { isTogglingHelpTips, areHelpTipsOn, handleToggleHelpTips } = useHelpTipsVM();

  return (
    <ListItem disableGutters disablePadding>
      <ListItemButton
        id="toggle-help-tips"
        onClick={handleToggleHelpTips}
        disabled={isTogglingHelpTips}
        aria-busy={isTogglingHelpTips}
        role="switch"
        aria-checked={areHelpTipsOn}
        aria-labelledby={HELP_TIPS_LABEL_ID}
      >
        <ListItemIcon>{isTogglingHelpTips ? <SpinnerIcon /> : <BulbIcon />}</ListItemIcon>
        <ListItemText>
          <Typography id={HELP_TIPS_LABEL_ID} variant="h6Regular" component="div">
            {t('help_tips', { ns: i18nNS.SETTINGS })}
          </Typography>
        </ListItemText>
        <Switch edge="end" checked={areHelpTipsOn} readOnly />
      </ListItemButton>
    </ListItem>
  );
};

export default HelpTips;
